import request from '../../utils/request'
import da from "element-ui/src/locale/lang/da";

// 获取用户充值的二维码
export function getTheQRCodeOfUserRecharge(rechargeAmount) {
  return request({
    url: 'recharge/personal-recharge',
    method: 'get',
    params: {'rechargeAmount': rechargeAmount}
  })
}


// 验证提现用户
export function verifyWithdrawalUser(data) {
  return request({
    url: 'withdrawal/authenticationUser',
    method: 'post',
    data: data
  })
}


/**
 *
 * @param data
 * @returns {AxiosPromise}
 */
export function getUserAccountBalance() {
  return request({
    url: 'recharge/get_user_account_balance',
    method: 'get',
  })
}

/**
 *
 * @param data 提现需要的参数
 * @returns {AxiosPromise}
 */
export function userWithdrawal(data) {
  return request({
    url: 'withdrawal/authenticationUser',
    method: 'post',
    data: data
  })
}


/**
 *
 * @param data 提现需要的参数
 * @returns {AxiosPromise}
 */
export function getUserAuthenticationQRCode() {
  return request({
    url: 'withdrawal/get_user_authentication_qr_code',
    method: 'get',
  })
}

// 获取企业的的网址
export function getTheWebsiteOfTheEnterprise(refundAmount) {
  return request({
    url: 'recharge/enterprise-refund',
    method: 'get',
    params: {'refundAmount': refundAmount}
  })
}

// 获得提现手续费率
export function getWithdrawHandlingFee() {
  return request({
    url: '/withdrawal/getWithdrawHandlingFee',
    method: 'get',
  })
}
// 获得充值退款手续费率
export function getRefundHandlingFee() {
  return request({
    url: '/withdrawal/getRefundHandlingFee',
    method: 'get',
  })
}


/**
 * 提现 保存提交接口
 * @param data 提现需要的参数
 * @returns {AxiosPromise}
 */
 export function setwithdraw(data) {
  return request({
    url: '/withdrawal/withdraw',
    method: 'post',
    data: data
  })
}

/**
 * 充值退回 保存提交接口
 * @param data 充值退回需要的参数
 * @returns {AxiosPromise}
 */
 export function setrefund(data) {
  return request({
    url: '/withdrawal/refund',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/myAccount/index.js